angular.module('TetherApp').factory('ticketService', [
    '$http',
    function ($http) {

        let randomString = function (length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };


        let setStatus = function (client, ticket, status, ticketEscalatedText) {
            // console.log(status);
            return $http.post(
                '/' + client + '/ticket/' + ticket + '/set-status',
                {
                    status: status,
                    ticketEscalatedText: ticketEscalatedText
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            setStatus: setStatus
        }

    }
]);
